import * as actions from "./actionsTypes";

const initialData = {
  loading: false,
  loadingById: false,
  saveLoading: false,
  factorsLength: 0,
  factors: [],
  factor: {},
  factorError: "",
  formError: "",
};

export default function FactorReducer(state = initialData,action) {
  switch (action.type) {
    case actions.LOADING_FACTOR:
      return { ...state, loading: action.payload };
    case actions.LOADING_FACTOR_BY_ID:
      return { ...state, loadingById: action.payload };
    case actions.SAVE_LOADING_FACTOR:
      return { ...state, saveLoading: action.payload };
    case actions.GET_FACTOR:
      return {
        ...state,
        factors: action.payload.factors,
        factorsLength: action.payload.factorsLength,
      };
    case actions.GET_FACTOR_BY_ID:
      return {
        ...state, factor: action.payload
      };
    case actions.FORM_FAIL:
      return { ...state, formError: action.payload };
    case actions.FACTOR_FAIL:
      return { ...state, factorError: action.payload };
    default:
      return state;
  }
}
